// Courses API: api/courseapi/GetCourses/{product}/{industry}/{producttype}/{pageNumber}/{pageId}/{language}
// Drop downs API: api/courseapi/getdropdowns/{pageId}/{language}
// see also productsOverview


if ($('.courses-list-page').length > 0) {

    var breakpoints = {
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1260
    },
        viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
        getUrl = window.location,
        baseUrl = getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[0],
        maxVisible = 10;

    if (viewportWidth < breakpoints.md) {
        maxVisible = 5;
    }
    if (viewportWidth < breakpoints.sm) {
        maxVisible = 3;
    }





	// get params from url
	var getUrlParameter = function getUrlParameter(sParam) {
		var sPageURL = decodeURIComponent(window.location.search.substring(1)),
			sURLVariables = sPageURL.split('&'),
			sParameterName,
			i;

		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');

			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined ? true : sParameterName[1];
			}
		}
	};


	var manufacturer = getUrlParameter('manufacturer') === undefined ? 'all' : getUrlParameter('manufacturer'),
		industry = getUrlParameter('industry') === undefined ? 'all' : getUrlParameter('industry'),
		productType = getUrlParameter('productType') === undefined ? 'all' : getUrlParameter('productType'),
		pageNumber = getUrlParameter('pageNumber') === undefined ? '1' : getUrlParameter('pageNumber'),
		language = getUrlParameter('language') === undefined ? $('html').attr('lang') : getUrlParameter('language');







    // render drop down filters
    var pageId = $('.courses-list-page').attr('data-pagetypeid'),
        filtersUrl = baseUrl + 'api/courseapi/getdropdowns/' + pageId + '/' + language + '/' + manufacturer + '/' + industry + '/' + productType;

    $.get(filtersUrl, function(data) {
        $('.courses-filters').html(data);
    });




	// push params to url
	$.fn.pushState = function(manufacturer, industry, productType, pageNumber) {
		if (manufacturer == undefined || manufacturer == ' ') {
			manufacturer = 'all';
		}
		if (industry == undefined || industry == ' ') {
			industry = 'all';
		}
		if (productType == undefined || productType == ' ') {
			productType = 'all';
		}
		if (pageNumber == undefined || pageNumber == ' ') {
			pageNumber = '1';
		}

		history.pushState(null, null, '?manufacturer=' + manufacturer + '&industry=' + industry + '&productType=' + productType + '&pageNumber=' + pageNumber + '&language=' + language);
	};





    // Get initial manufacturers list - default vars
    var coursesUrl = baseUrl + 'api/courseapi/GetCourses/'+ manufacturer + '/' + industry + '/' + productType + '/' + pageNumber + '/' + pageId + '/false/' + language;

    $.get(coursesUrl, function(data) {
        $('section.courses-list').html(data.Html);
        $.fn.pagination(data.Pages);
    });



	// reset all filters
	$('#reset').on('click', function() {
		manufacturer = 'all',
		industry = 'all',
		productType = 'all',
		pageNumber = '1';

		$.fn.pushState(manufacturer, industry, productType, pageNumber);

		window.location.reload();
	});





	// Update courses list with filtered courses
    $.fn.renderFilteredCourses = function() {
	    manufacturer = getUrlParameter('manufacturer') === undefined ? 'all' : getUrlParameter('manufacturer'),
	    industry = getUrlParameter('industry') === undefined ? 'all' : getUrlParameter('industry'),
	    productType = getUrlParameter('productType') === undefined ? 'all' : getUrlParameter('productType'),
	    pageNumber = getUrlParameter('pageNumber') === undefined ? '1' : getUrlParameter('pageNumber');

        var coursesUrl = baseUrl + 'api/courseapi/GetCourses/'+ manufacturer + '/' + industry + '/' + productType + '/' + pageNumber + '/' + pageId + '/false/' + language;

        $.get(coursesUrl , function(data) {
            $('section.courses-list').html(data.Html).hide().fadeIn();
        });
        $(window).scrollTop(0);
    };





    // pagination
    $.fn.pagination = function (pages) {
        if (pages > 1 && pages < maxVisible) {
            $('#pagination').bootpag({
                total: pages,
                maxVisible: pages,
                wrapClass: 'pagination justify-content-center',
                next: ' ',
                prev: ' ',
                nextClass: 'hidden',
                prevClass: 'hidden',
                page: pageNumber,
                firstLastUse: false,
            });
        } else if (pages > 1) {
            $('#pagination').bootpag({
                total: pages,
                maxVisible: maxVisible,
                wrapClass: 'pagination justify-content-center',
                next: '. . .',
                prev: '. . .',
                page: pageNumber,
                firstLastUse: true,
                first: '',
                last: ''
            });
        } else {
            $('#pagination ul').remove();
        }
    };





    // Update list on pagination click
    $.fn.paginationClick = function() {
        $('#pagination').unbind('page').bootpag().on('page', function(event, pageNumber){

	        // add params to url
	        $.fn.pushState(manufacturer, industry, productType, pageNumber, language);

            $.fn.renderFilteredCourses();
        });
    };

    // initiate pagination listener
    $.fn.paginationClick();






    // filter courses by manufacturer, industry, and product type - update pagination with correct number of pages - start on page 1
    $('.courses-filters').on('change', function() {
        $('#product, #industry, #productType').children(':selected').attr('selected', 'selected').siblings().removeAttr('selected');

        manufacturer = $('#product option:selected').val(),
        industry = $('#industry option:selected').val(),
        productType = $('#productType option:selected').val(),
	    pageNumber = '1';


	    // add params to url
	    $.fn.pushState(manufacturer, industry, productType, pageNumber, language);

        // get filtered manufacturers
        $.fn.renderFilteredCourses();

        // and pagination
        var coursesUrl = baseUrl + 'api/courseapi/GetCourses/'+ manufacturer + '/' + industry + '/' + productType + '/' + pageNumber + '/' + pageId + '/false/' + language;
        $.get(coursesUrl, function(data) {
            $.fn.pagination(data.Pages);
        });

        $.fn.paginationClick();
    });
};